/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ElectronBeamQualityDoseRateValueListDto } from './ElectronBeamQualityDoseRateValueListDto';
import {
    ElectronBeamQualityDoseRateValueListDtoFromJSON,
    ElectronBeamQualityDoseRateValueListDtoFromJSONTyped,
    ElectronBeamQualityDoseRateValueListDtoToJSON,
} from './ElectronBeamQualityDoseRateValueListDto';
import type { PhotonBeamQualityDoseRateValueListDto } from './PhotonBeamQualityDoseRateValueListDto';
import {
    PhotonBeamQualityDoseRateValueListDtoFromJSON,
    PhotonBeamQualityDoseRateValueListDtoFromJSONTyped,
    PhotonBeamQualityDoseRateValueListDtoToJSON,
} from './PhotonBeamQualityDoseRateValueListDto';

/**
 * 
 * @export
 * @interface BeamQualityContainerDto
 */
export interface BeamQualityContainerDto {
    /**
     * 
     * @type {Array<ElectronBeamQualityDoseRateValueListDto>}
     * @memberof BeamQualityContainerDto
     */
    beamQualitiesElectron: Array<ElectronBeamQualityDoseRateValueListDto>;
    /**
     * 
     * @type {Array<PhotonBeamQualityDoseRateValueListDto>}
     * @memberof BeamQualityContainerDto
     */
    beamQualitiesPhoton: Array<PhotonBeamQualityDoseRateValueListDto>;
    /**
     * 
     * @type {string}
     * @memberof BeamQualityContainerDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BeamQualityContainerDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BeamQualityContainerDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamQualityContainerDto
     */
    $type?: BeamQualityContainerDtoTypeEnum;
}


/**
 * @export
 */
export const BeamQualityContainerDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersBeamQualityContainerDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.BeamQualityContainerDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamQualityContainerDtoTypeEnum = typeof BeamQualityContainerDtoTypeEnum[keyof typeof BeamQualityContainerDtoTypeEnum];


/**
 * Check if a given object implements the BeamQualityContainerDto interface.
 */
export function instanceOfBeamQualityContainerDto(value?: unknown): value is BeamQualityContainerDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamQualityContainerDtoTypeEnum)[0];
}

export function BeamQualityContainerDtoFromJSON(json: any): BeamQualityContainerDto {
    return BeamQualityContainerDtoFromJSONTyped(json, false);
}

export function BeamQualityContainerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamQualityContainerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'beamQualitiesElectron': ((json['beamQualitiesElectron'] as Array<any>).map(ElectronBeamQualityDoseRateValueListDtoFromJSON)),
        'beamQualitiesPhoton': ((json['beamQualitiesPhoton'] as Array<any>).map(PhotonBeamQualityDoseRateValueListDtoFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isRequired': !exists(json, 'isRequired') ? undefined : json['isRequired'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function BeamQualityContainerDtoToJSON(value?: BeamQualityContainerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'beamQualitiesElectron': ((value.beamQualitiesElectron as Array<any>).map(ElectronBeamQualityDoseRateValueListDtoToJSON)),
        'beamQualitiesPhoton': ((value.beamQualitiesPhoton as Array<any>).map(PhotonBeamQualityDoseRateValueListDtoToJSON)),
        'name': value.name,
        'isRequired': value.isRequired,
        'isEnabled': value.isEnabled,
        '$type': value.$type,
    });
}

